<template>
  <div class="email-form">
    <LabelInput :class="{ 'has-error': errors.email }">
      <label for="email">{{ $t('ACCOUNT.CONTACT.EMAIL') }}</label>
      <DebounceInput
        id="email"
        type="text"
        :model-value="email"
        @update:model-value="updateEmail"
      />
      <div v-if="errors.email" class="field-info">
        <small class="error-info">
          {{ $t(errors.email) }}
        </small>
      </div>
    </LabelInput>
    <LabelInput :class="{ 'has-error': errors.password }">
      <label for="emailPassword">{{
        $t('ACCOUNT.ACCOUNT.OLD_PASSWORD')
      }}</label>
      <DebounceInput
        id="emailPassword"
        :type="revealPassword ? 'text' : 'password'"
        :model-value="password"
        @update:model-value="setPassword"
      />
      <Icon
        class="reveal-password"
        :icon="revealPassword ? 'eye-crossed' : 'eye'"
        @click="toggleRevealPassword"
      ></Icon>
      <div v-if="errors.password" class="field-info">
        <small class="error-info">
          {{ $t(errors.password) }}
        </small>
      </div>
    </LabelInput>
    <AccountPageActions
      :save="changeEmail"
      :disabled="!emailChanged"
      @on-revert="revertEmail"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from 'pinia';

import AccountPageActions from '../AccountPageActions.vue';
import DebounceInput from 'src/app/components/input/DebounceInput.vue';
import LabelInput from 'commons/labelInput/LabelInput.vue';
import { useIdentityStore } from 'commons/stores/identity';

export default {
  name: 'PersonalDataForm',
  components: {
    LabelInput,
    DebounceInput,
    AccountPageActions,
  },
  props: {},
  data() {
    return {
      errors: {
        email: null,
        password: null,
      },
      password: null,
      revealPassword: false,
    };
  },
  computed: {
    ...mapState(useIdentityStore, ['email', 'emailChanged']),
  },
  created() {},
  unmounted() {
    this.resetEmail();
  },
  methods: {
    ...mapActions(useIdentityStore, [
      'setEmail',
      'resetEmail',
      'saveEmail',
      'fetchIdentity',
    ]),
    updateEmail(email) {
      this.resetErrors();
      this.setEmail(email);
    },
    setPassword(password) {
      this.resetErrors();
      this.password = password;
    },
    toggleRevealPassword() {
      this.revealPassword = !this.revealPassword;
    },
    async changeEmail() {
      try {
        await this.saveEmail(this.password);
        this.password = null;
      } catch (error) {
        this.setErrors(error);
        throw error;
      }
    },
    revertEmail() {
      this.resetErrors();
      this.resetEmail();
    },
    resetErrors() {
      this.errors.email = null;
      this.errors.password = null;
    },
    setErrors(error) {
      switch (error?.status) {
        case 401:
          this.errors.password =
            'ACCOUNT.PASSWORD.ERRORS.CURRENT_PASSWORD_WRONG';
          return;
        case 400:
          if (!this.password) {
            this.errors.password =
              'ACCOUNT.PASSWORD.ERRORS.CURRENT_PASSWORD_WRONG';
            return;
          }
      }

      switch (error?.data?.error) {
        case '-00001':
          this.errors.email = 'ACCOUNT.ERRORS.INVALID_FORMAT';
          return;
        case '000005':
          this.errors.email = 'ACCOUNT.ERRORS.EMAIL_IN_USE';
          return;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'src/scss/styleguide/colors';
@import 'src/scss/styleguide/_type.scss';

.email-form {
  max-width: 600px;
}

.labelInput {
  margin: 0 0 16px 0;

  :deep(.error-icon) {
    display: none !important;
  }
}

.reveal-password {
  position: absolute;
  right: 10px;
  top: 10px;

  width: 18px;
  height: 18px;

  color: $pa-color-main;
  cursor: pointer;
}
</style>
